import React, { useState } from "react";
import {
  Container,
  Image,
  Nav,
  Tab,
  Row,
  Col,
  InputGroup,
  Form,
  Table,
  Button,
} from "react-bootstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import ImageGallery from 'react-image-gallery';
import NumericInput from 'react-numeric-input';
import ReactStars from "react-rating-stars-component";
import "./Product.css";
import FeaturesProduct from "./FeaturesProduct";
import { useEffect } from "react";
import { singleProductStart } from "../../store/slices/ProductSlice";
import { useDispatch, useSelector } from "react-redux";
import Skeleton from "react-loading-skeleton";
import SomethingWentWrong from "../Helper/SomethingWentWrong";
import { useTranslation } from "react-multi-lang";
import { cartSaveStart, localCartList } from "../../store/slices/CartSlice";
import {
  fetchProductReviewListStart,
  fetchMoreProductReviewListStart,
} from "../../store/slices/ProductSlice";
import { productListStart } from "../../store/slices/ProductSlice";
import NoDataFound from "../Helper/NoDataFound";
import { wishlistSaveStart } from "../../store/slices/ProductSlice";
import WriteReviewModal from "../Profile/WriteReviewModal";
import AuthModal from "../Auth/AuthModal";

const SingleProductIndex = () => {
  const t = useTranslation("single_product");
  const navigate = useNavigate();
  const params = useParams();
  const dispatch = useDispatch();
  const singleProduct = useSelector(state => state.product.singleProduct);
  const profile = useSelector(state => state.user.profile);
  const localCart = useSelector(state => state.cart.localCart);
  const productReviews = useSelector(state => state.product.productReviews);
  const wishlistSave = useSelector(state => state.product.wishlistSave);

  const [writeReview, setWriteReview] = useState(false);

  const closeWriteReviewModal = () => {
    setWriteReview(false);
  };

  const [skipRender, setSkipRender] = useState(true);
  const [isWishlisted, setIsWishlisted] = useState(false);
  const [selectedAttribute, setSelectedAttribute] = useState(null);
  const [login, setLogin] = useState(false);
  const [selectedData, setSelectedData] = useState({
    size: "",
    weight: "",
  });

  const productList = useSelector(state => state.product.productList);

  const closeLoginModal = () => {
    setLogin(false);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    dispatch(
      singleProductStart({ product_unique_id: params.productUniqueId })
    );
    const local = localStorage.getItem("cart");
    dispatch(localCartList(local && local.length > 0 ? JSON.parse(local) : []))
    dispatch(
      fetchProductReviewListStart({
        product_unique_id: params.productUniqueId,
        skip: 0,
        take: 2,
      })
    );
    dispatch(
      productListStart({
        order_by: "newest",
        skip: 0,
        take: 4,
      })
    );
  }, [params.productUniqueId]);

  useEffect(() => {
    if (!skipRender && !singleProduct.loading && Object.keys(singleProduct.data).length > 0) {
      setIsWishlisted(singleProduct.data.product.is_wishlisted ? true : false);
      if (singleProduct.data.product.product_attributes.length > 0)
        if (selectedAttribute)
          setSelectedAttribute(singleProduct.data.product.product_attributes.find(attr => attr.product_attribute_id === selectedAttribute.product_attribute_id));
        else {
          let productAttribute = singleProduct.data.product.product_attributes.find(attribute => attribute.product_attribute_id == params.productAttributeId)
          if (!productAttribute) productAttribute = singleProduct.data.product.product_attributes[0];
          setSelectedAttribute(productAttribute);
          setSelectedData({
            size: productAttribute.sizes.length > 0 ? productAttribute.sizes[0] : "",
            weight: productAttribute.weights.length > 0 ? productAttribute.weights[0] : "",
          })
        }
    }
    setSkipRender(false);
  }, [singleProduct]);

  useEffect(() => {
    if (selectedAttribute)
      setSelectedData({
        size: selectedAttribute.sizes.length > 0 ? selectedAttribute.sizes[0] : "",
        weight: selectedAttribute.weights.length > 0 ? selectedAttribute.weights[0] : "",
      })
  }, [selectedAttribute]);

  const onCartClick = (e) => {
    e.preventDefault();
    //User Add to cart
    if (isCarted())
      navigate("/cart");
    else
      dispatch(
        cartSaveStart({
          product_attribute_id: selectedAttribute.product_attribute_id,
          quantity: 1,
          ...selectedData,
        })
      );
  };

  const onGuestCartClick = e => {
    e.preventDefault();
    if (isGuestCarted())
      navigate("/cart");
    else
      dispatch(localCartList([...localCart, {
        quantity: 1,
        product_attribute_id: selectedAttribute.product_attribute_id,
        ...selectedData
      }]))
  }

  const isCarted = () => {
    const value = singleProduct.data.carts.filter(product => product.product_attribute_id === selectedAttribute.product_attribute_id)
      .filter(product => product.size === selectedData.size)
      .filter(product => product.weight === selectedData.weight)
      .length > 0;
    return value;
  }

  const isGuestCarted = () => {
    const value = localCart.filter(product => product.product_attribute_id === selectedAttribute.product_attribute_id)
      .filter(product => product.size === selectedData.size)
      .filter(product => product.weight === selectedData.weight)
      .length > 0;
    return value;
  }


  const wishListToggle = () => {
    if (Object.keys(profile.data).length > 0) {
      dispatch(
        wishlistSaveStart({
          product_unique_id: singleProduct.data.product.product_unique_id,
        })
      );
    } else {
      setLogin(true);
    }
  };

  const writeReviews = () => {
    if (Object.keys(profile.data).length > 0) {
      setWriteReview(true);
    } else {
      setLogin(true);
    }
  }

  return (
    <>
      <div className="single-product-sec">
        {singleProduct.loading ?
          <Container>
            <Row>
              <Col md={6}>
                <Skeleton className="product-image-loader" />
              </Col>
              <Col md={6}>
                <Skeleton height={100} />
                <Skeleton count={2} width={300} />
                <Skeleton count={4} />
                <Skeleton height={200} />
              </Col>
            </Row>
          </Container>
          : singleProduct.data.product ?
            <>
              <Container>
                <Row>
                  <Col md={7}>
                    <div className="single-product-full-img-sec">
                      {selectedAttribute?.product_files.length > 0 ?
                        <ImageGallery items={selectedAttribute.product_files} thumbnailPosition="left" />
                        : singleProduct.data.product.product_files.length > 0 ?
                          <ImageGallery items={singleProduct.data.product.product_files} thumbnailPosition="left" />
                          : <Image src={singleProduct.data.product.file} />
                      }
                    </div>
                  </Col>
                  <Col md={5}>
                    <div className="single-product-info-sec">
                      <div className="product-rating-sec">
                        <ReactStars
                          count={5}
                          edit={false}
                          size={24}
                          isHalf={true}
                          emptyIcon={<i className="far fa-star"></i>}
                          halfIcon={<i className="fas fa-star-half-alt"></i>}
                          fullIcon={<i className="fas fa-star"></i>}
                          activeColor="#ffd700"
                          value={singleProduct.data.product.review_stars}
                          key={`stars_${singleProduct.data.product.review_stars}`}
                        />
                        <Link to="#"
                          className="write-review-link"
                          onClick={writeReviews}
                        >
                          <div className="single-product-review">
                            <span>{t("write_review")}</span>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                            >
                              <path d="M21 11.5V15h-3a3 3 0 00-3 3v3H4.5A1.5 1.5 0 013 19.5v-15A1.5 1.5 0 014.5 3h9A1.5 1.5 0 0015 1.5 1.5 1.5 0 0013.5 0h-9A4.5 4.5 0 000 4.5v15A4.5 4.5 0 004.5 24h11.984a4.5 4.5 0 003.181-1.317l3.017-3.017A4.5 4.5 0 0024 16.485V11.5a1.5 1.5 0 00-1.5-1.5 1.5 1.5 0 00-1.5 1.5z"></path>
                              <path d="M17.793 1.793l-12.5 12.5A1 1 0 005 15v3a1 1 0 001 1h3a1 1 0 00.707-.293L22.038 6.376a3.379 3.379 0 00.952-3.17 3.118 3.118 0 00-5.197-1.413z"></path>
                            </svg>
                          </div>
                        </Link>
                        <div className="product-rating-count">
                          ({singleProduct.data.product.total_reviews})
                        </div>
                      </div>
                      <h4>{singleProduct.data.product.name}</h4>
                      {/* <div className="border-head-title"></div> */}
                      {/* <p className="single-product-desc">
                        {singleProduct.data.product.description_formatted}
                      </p> */}
                      <h3>{selectedAttribute?.selling_price_formatted}</h3>
                      <div className="material-btn-sec">
                        <span>{t("material")}: </span>
                        <div className="material-btn-box">
                          {singleProduct.data.product.product_attributes.map((material, i) =>
                            <Button
                              key={i}
                              className={`btn-theme-type-btn ${material.product_attribute_id === selectedAttribute?.product_attribute_id ? "active" : ""}`}
                              onClick={() => setSelectedAttribute(material)}
                            >
                              {material.metal ? material.metal : t("n_a")}
                            </Button>
                          )}
                        </div>
                      </div>
                      <div className="stock-availability">
                        {selectedAttribute?.stock_status ?
                          <h5>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              data-name="Layer 1"
                              viewBox="0 0 24 24"
                            >
                              <path d="M12 24a5.498 5.498 0 01-4.176-1.92 5.494 5.494 0 01-4.31-1.595 5.497 5.497 0 01-1.595-4.31C.707 15.136-.001 13.617-.001 12s.708-3.136 1.92-4.175a5.496 5.496 0 011.595-4.31 5.522 5.522 0 014.31-1.595 5.498 5.498 0 018.352 0 5.497 5.497 0 015.905 5.905c1.212 1.039 1.92 2.558 1.92 4.175s-.708 3.136-1.92 4.175a5.496 5.496 0 01-1.595 4.31 5.491 5.491 0 01-4.31 1.595A5.498 5.498 0 0112 24zm-3.274-4.095l.37.549a3.5 3.5 0 005.808 0l.37-.549.649.126a3.498 3.498 0 004.107-4.106l-.127-.65.55-.37a3.5 3.5 0 000-5.808l-.55-.37.127-.65a3.498 3.498 0 00-4.107-4.106l-.649.126-.37-.549a3.5 3.5 0 00-5.808 0l-.37.549-.649-.126A3.5 3.5 0 003.97 8.077l.127.65-.55.37a3.5 3.5 0 000 5.808l.55.37-.127.65a3.498 3.498 0 004.107 4.106l.649-.126zm3.184-4.485l5.793-5.707-1.404-1.425-5.809 5.701-2.793-2.707-1.393 1.437 2.782 2.696c.391.391.903.585 1.416.585s1.021-.193 1.407-.58z"></path>
                            </svg> <span>{t("in_stock")}</span>
                          </h5>
                          : <h5>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              data-name="Layer 1"
                              viewBox="0 0 24 24"
                            >
                              <path d="M12 24a5.498 5.498 0 01-4.176-1.92 5.494 5.494 0 01-4.31-1.595 5.497 5.497 0 01-1.595-4.31C.707 15.136-.001 13.617-.001 12s.708-3.136 1.92-4.175a5.496 5.496 0 011.595-4.31 5.522 5.522 0 014.31-1.595 5.498 5.498 0 018.352 0 5.497 5.497 0 015.905 5.905c1.212 1.039 1.92 2.558 1.92 4.175s-.708 3.136-1.92 4.175a5.496 5.496 0 01-1.595 4.31 5.491 5.491 0 01-4.31 1.595A5.498 5.498 0 0112 24zm-3.274-4.095l.37.549a3.5 3.5 0 005.808 0l.37-.549.649.126a3.498 3.498 0 004.107-4.106l-.127-.65.55-.37a3.5 3.5 0 000-5.808l-.55-.37.127-.65a3.498 3.498 0 00-4.107-4.106l-.649.126-.37-.549a3.5 3.5 0 00-5.808 0l-.37.549-.649-.126A3.5 3.5 0 003.97 8.077l.127.65-.55.37a3.5 3.5 0 000 5.808l.55.37-.127.65a3.498 3.498 0 004.107 4.106l.649-.126zm3.184-4.485l5.793-5.707-1.404-1.425-5.809 5.701-2.793-2.707-1.393 1.437 2.782 2.696c.391.391.903.585 1.416.585s1.021-.193 1.407-.58z"></path>
                            </svg> <span>{t("out_of_stock")}</span>
                          </h5>
                        }
                      </div>
                      {selectedAttribute?.sizes.length > 0 ?
                        <div className="size-btn-sec">
                          <span>{t("size")}</span>
                          <div className="size-btn-box">
                            {selectedAttribute.sizes.map((size, i) =>
                              <Button
                                key={i}
                                className={`btn-theme-type-btn ${size === selectedData.size ? "active" : ""}`}
                                onClick={() => setSelectedData({ ...selectedData, size: size })}
                              >
                                {size}
                              </Button>
                            )}
                          </div>
                        </div>
                        : null
                      }
                      {selectedAttribute?.weights.length > 0 ?
                        <div className="weight-btn-sec">
                          <span>{t("weight")}</span>
                          <div className="weight-btn-box">
                            {selectedAttribute.weights.map((weight, i) =>
                              <Button
                                key={i}
                                className={`btn-theme-type-btn ${weight === selectedData.weight ? "active" : ""}`}
                                onClick={() => setSelectedData({ ...selectedData, weight: weight })}
                              >
                                {weight}
                              </Button>
                            )}
                          </div>
                        </div>
                        : null
                      }
                      {/* <div className="hot-sale-sold-sec">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          x="0"
                          y="0"
                          enableBackground="new 0 0 512 512"
                          version="1.1"
                          viewBox="0 0 512 512"
                          xmlSpace="preserve"
                          fill="#F3705A"
                        >
                          <path d="M349.485 86.766c-25.569-21.67-51.906-44.15-78.561-70.72L255.731.96l-14.915 15.107c-47.985 48.113-70.656 121.987-80.5 166.307a128.565 128.565 0 01-16.556-37.97l-9.013-34.795-26.208 24.632C62.619 177.345 32 220.11 32 288.592c-.882 101.634 67.488 190.839 165.859 216.401a236.234 236.234 0 0043.915 6.392c4.864.352 18.793.703 21.18.554 120.685-3.63 216.608-102.565 216.507-223.305 0-91.494-60.236-142.633-129.976-201.868zm-89.627 382.282c-2.231.193-4.259.213-6.516.192-39.844-1.218-71.54-33.819-71.637-73.681 0-27.002 14.481-40.461 47.254-68.357 8.262-7.027 17.249-14.672 26.704-23.425 8.284 7.517 16.333 14.332 23.765 20.656 32.922 27.939 50.107 43.804 50.107 71.062-.074 39.104-30.634 71.364-69.677 73.553zm106.901-37.714l-.426.298a116.126 116.126 0 005.792-36.074c0-48.233-31.645-75.108-65.12-103.537-11.861-10.051-24.106-20.443-36.329-32.667l-15.077-15.056-15.056 15.056c-13.799 13.778-27.3 25.277-39.204 35.414-33.391 28.408-62.246 52.961-62.246 100.79a115.901 115.901 0 006.389 37.543 181.328 181.328 0 01-70.891-144.679 141.338 141.338 0 0140.226-100.087 165.027 165.027 0 0015.929 25.959 38.331 38.331 0 0039.524 14.502 39.524 39.524 0 0030.09-30.452 348.763 348.763 0 0156.56-136.289c22.466 21.295 44.72 40.141 64.801 57.199 66.696 56.645 114.994 97.574 114.994 169.296a179.966 179.966 0 01-69.976 142.784h.02z"></path>
                        </svg>
                        <p>34 sold in last 10 hours</p>
                      </div>
                      <div className="people-view-count-sec">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                        >
                          <path d="M23.271 9.419C21.72 6.893 18.192 2.655 12 2.655S2.28 6.893.729 9.419a4.908 4.908 0 000 5.162C2.28 17.107 5.808 21.345 12 21.345s9.72-4.238 11.271-6.764a4.908 4.908 0 000-5.162zm-1.705 4.115C20.234 15.7 17.219 19.345 12 19.345S3.766 15.7 2.434 13.534a2.918 2.918 0 010-3.068C3.766 8.3 6.781 4.655 12 4.655s8.234 3.641 9.566 5.811a2.918 2.918 0 010 3.068z"></path>
                          <path d="M12 7a5 5 0 105 5 5.006 5.006 0 00-5-5zm0 8a3 3 0 113-3 3 3 0 01-3 3z"></path>
                        </svg>
                        <p>38 people are viewing right now</p>
                      </div> */}
                      {selectedAttribute ?
                        <div className="single-product-quantity-sec">
                          {/* <div className="">
                            <NumericInput mobile className="form-control" />
                          </div> */}
                          <div className="add-wishlist-btn-sec">
                            {profile.buttonDisable ?
                              null
                              : profile.data.user_id ?
                                <Button className="add-wishlist-btn" onClick={onCartClick}>
                                  {isCarted()
                                    ? t("go_to_cart")
                                    : t("cart_btn.text")
                                  }
                                </Button>
                                : <Button className="add-wishlist-btn" onClick={onGuestCartClick}>
                                  {isGuestCarted()
                                    ? t("go_to_cart")
                                    : t("cart_btn.text")
                                  }
                                </Button>
                            }
                          </div>
                          <Link
                            to="#"
                            className="product-search-cart-icon-sec"
                            onClick={wishListToggle}
                          >
                            <div className="heart-icon-sec">
                              {isWishlisted ? (
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                >
                                  <path d="M17.5 1.917a6.4 6.4 0 00-5.5 3.3 6.4 6.4 0 00-5.5-3.3A6.8 6.8 0 000 8.967c0 4.547 4.786 9.513 8.8 12.88a4.974 4.974 0 006.4 0c4.014-3.367 8.8-8.333 8.8-12.88a6.8 6.8 0 00-6.5-7.05z"></path>
                                </svg>
                              ) : (
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="#F1F1F1"
                                >
                                  <path d="M17.5 1.917a6.4 6.4 0 00-5.5 3.3 6.4 6.4 0 00-5.5-3.3A6.8 6.8 0 000 8.967c0 4.547 4.786 9.513 8.8 12.88a4.974 4.974 0 006.4 0c4.014-3.367 8.8-8.333 8.8-12.88a6.8 6.8 0 00-6.5-7.05z"></path>
                                </svg>
                              )}
                            </div>
                          </Link>
                        </div>
                        : null
                      }
                      {/* <div className="product-list-btn-sec">
                        <Link to="#" className="default-btn w-100">
                          Buy Now
                        </Link>
                      </div> */}
                    </div>
                  </Col>
                </Row>
                {singleProduct.data.product.description_formatted ||
                  singleProduct.data.product.total_reviews > 0 ?
                  <div className="single-product-review-sec">
                    <Row>
                      <Col md={12}>
                        <div className="single-product-review-wrapper">
                          <div className="single-product-tab-sec">
                            <Tab.Container id="left-tabs-example" defaultActiveKey={
                              singleProduct.data.product.description_formatted ? "description" : "reviews"
                            }>
                              <Row>
                                <Col sm={12}>
                                  <Nav variant="pills">
                                    {singleProduct.data.product.description_formatted ?
                                      <Nav.Item>
                                        <Nav.Link eventKey="description">{t("description")}</Nav.Link>
                                      </Nav.Item>
                                      : null
                                    }
                                    {singleProduct.data.product.total_reviews > 0 ?
                                      <Nav.Item>
                                        <Nav.Link eventKey="reviews">{t("reviews")}</Nav.Link>
                                      </Nav.Item>
                                      : null
                                    }
                                  </Nav>
                                </Col>

                                <Col sm={12}>
                                  <Tab.Content>
                                    <Tab.Pane eventKey="description">
                                      <div className="single-product-description-sec">
                                        {singleProduct.data.product.description_formatted}
                                      </div>
                                    </Tab.Pane>
                                    <Tab.Pane eventKey="reviews">
                                      {productReviews.loading ?
                                        <Skeleton count={3} height={100} /> :
                                        Object.keys(productReviews.data).length > 0 &&
                                          productReviews.data.reviews.length > 0 ?
                                          <>
                                            <div className="single-product-review-box">
                                              {productReviews.data.reviews.map(
                                                (review, i) => (
                                                  <div className="single-product-review-item" key={i}>
                                                    <div className="single-product-review-left">
                                                      <div className="single-product-review-user-img-sec">
                                                        <Image
                                                          className="single-product-review-user-img"
                                                          src={review.user
                                                            ? review.user.picture :
                                                            window.location.origin +
                                                            "/assets/img/profile/profile-placeholder.png"
                                                          }
                                                        />
                                                      </div>
                                                      <div className="single-product-review-info">
                                                        <h4>
                                                          {review.user
                                                            ? review.user.name
                                                            : t("na")
                                                          }
                                                        </h4>
                                                        {review.review !== "" ?
                                                          <p>{review.review}</p>
                                                          :
                                                          null
                                                        }
                                                        <ReactStars
                                                          count={5}
                                                          value={review.star}
                                                          key={`stars_${i}_${review.star}`}
                                                          size={24}
                                                          isHalf={true}
                                                          edit={false}
                                                          emptyIcon={
                                                            <i className="far fa-star"></i>
                                                          }
                                                          halfIcon={
                                                            <i className="fa fa-star-half-alt"></i>
                                                          }
                                                          fullIcon={
                                                            <i className="fa fa-star"></i>
                                                          }
                                                          activeColor="#ffd700"
                                                        />
                                                      </div>
                                                    </div>
                                                  </div>
                                                )
                                              )}
                                            </div>
                                            <div className="text-center">
                                              {productReviews.data.reviews.length <
                                                productReviews.data.total_reviews ? (
                                                productReviews.loadMore ? (
                                                  <Skeleton height={100} count={3} />
                                                ) : (
                                                  <div className="default-btn-sec">
                                                    <div className="single-product-review-btn-sec">
                                                      <Link
                                                        to={`/product-reviews/${singleProduct.data.product.product_unique_id}`}
                                                        className="default-btn"
                                                      >
                                                        {t("load_more")}
                                                      </Link>
                                                    </div>
                                                  </div>
                                                )
                                              ) : null}
                                            </div>
                                          </>
                                          :
                                          <NoDataFound />
                                      }
                                    </Tab.Pane>
                                  </Tab.Content>
                                </Col>

                              </Row>
                            </Tab.Container>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                  :
                  null
                }
              </Container>
              {productList.loading ? (
                <div className="features-product-sec">
                  {[...Array(3)].map((val, i) => <Skeleton height={445} key={i} />)}
                </div>
              ) : productList.data.products &&
                productList.data.products.length > 0 ? (
                <div className="features-product-sec">
                  <Container>
                    <Row>
                      <Col md={12}>
                        <div className="section-title">
                          <h1 className="text-uppercase">{t("top_selling_products")}</h1>
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={12}>
                        <FeaturesProduct
                          products={
                            productList.data.products
                              .filter(product => product.product_unique_id !== singleProduct.data.product.product_unique_id)
                              .slice(0, 8)
                          }
                        />
                      </Col>
                    </Row>
                  </Container>
                </div>
              ) : null}

            </>
            : <Container>
              <SomethingWentWrong />
            </Container>
        }
      </div >
      {
        writeReview && singleProduct.data.product && (
          <WriteReviewModal
            writeReview={writeReview}
            closeWriteReviewModal={closeWriteReviewModal}
            setWriteReview={setWriteReview}
            singleProduct={singleProduct.data.product}
          />
        )
      }
      {
        login ?
          <AuthModal closeLoginModal={closeLoginModal} />
          : null
      }
    </>
  );
};

export default SingleProductIndex;
